import {Extent, intersects} from 'ol/extent';
import Feature from 'ol/Feature';
import {defineStore} from 'pinia';
import {useKlipApiProxy} from '@/plugins/proxy-client';
import { EnvelopeOfLambert72ToLambert2008ConversionResponse } from '@/api/klip-api.proxy';

export const useGeometryProjectionStore = defineStore('geometry-projection-store', () => {

    const isLambert2008 = (feature: Feature): boolean => {
        // const projectionExtent72: Extent = [22000, 153000, 259000, 245000];
        const projectionExtent2008: Extent = [500000.0, 537856.0, 762144.0, 800000.0];
        return intersects(projectionExtent2008, feature.getGeometry().getExtent());
    }

    const transformFeatureToLambert2008 = (feature: Feature) => {
        const src = 'EPSG:31370';
        const dest = 'EPSG:3812';
        feature.getGeometry().transform(src, dest);
    }

    const transformWktToLambert2008 = async (wkt: string): Promise<string> => {
        try {
            const response: EnvelopeOfLambert72ToLambert2008ConversionResponse = await useKlipApiProxy().geometries_ConvertLambert72ToLambert2008(wkt);
            if (!response?.result?.conversionSuccess) {
                console.error('transformWktToLambert2008: conversion failed', response?.result?.errorMessage);
                return null;
            }
            return response.result.wkt;
        }
        catch (e) {
            console.error('transformWktToLambert2008: backend exception');
            return null;
        }
    }

    return {
        isLambert2008,
        transformFeatureToLambert2008,
        transformWktToLambert2008,
    }
})
